import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/store';
import { MdAddBox } from "react-icons/md";

import { Question, questionTypesArray, Rating, Scale, ShortResponse, Survey } from '../types';
import TextField from '../Components/TextField';
import Modal from './Modal';
import { addSurveyQuestion, updateSurveyQuestion } from '../Firebase/utils';
import { addQuestion, updateQuestion } from '../store/features/CreateSurveySlice';

interface RatingFormProps {
    question?: Question;
    openState: boolean;
    onClose: (result?: any) => void;
}

const isScale = (questionBody: any): questionBody is Rating => {
    return questionBody && typeof questionBody.min === 'number' && typeof questionBody.max === 'number';
};

const ScaleForm: React.FC<RatingFormProps> = (props: RatingFormProps) => {

    const { openState, onClose } = props;

    const user = useAppSelector(state => state.user.user);
    const survey = useAppSelector(state => state.survey.survey);
    const dispatch = useAppDispatch();
    const [question, setQuestion] = useState<Question>(props.question || {
        id: uuidv4(),
        questionText: '',
        type: 'Rating',
        questionBody: {
            min: 1,
            max: 5
        } as Rating
    });

    const handleInputChange = (field: keyof Scale, value: string) => {
        const parsedValue = value === '' ? 0 : parseInt(value, 10);
        setQuestion(prevQuestion => ({
            ...prevQuestion,
            questionBody: {
                ...prevQuestion.questionBody,
                [field]: parsedValue
            }
        }));
    };

    const handleDelete = async () => {
        try{
            console.log('Deleting...');
            await addSurveyQuestion(user, survey, question);
            dispatch(addQuestion({question, response: { questionId: question.id, questionText:question.questionText, questionType:question.type, results:[] }}));
            props.onClose();
        }catch(err){
            alert(err);
        }
    };

    const handleUpdate = async () => {
        try{
            console.log('Updating...');
            await updateSurveyQuestion(user, survey, question);
            dispatch(updateQuestion(question));
            props.onClose();
        }catch(err){
            alert(err);
        }
    };

    const handleSubmit = () => {
        if (question.questionText === '') {
            alert('Please enter a question');
            return;
        }
        if (isScale(question.questionBody) && (question.questionBody.min === 0 || question.questionBody.max === 0 || question.questionBody.min >= question.questionBody.max)) {
            alert('Please enter valid scale values');
            return;
        }
        if (props.question) {
            handleUpdate();
        } else {
            handleDelete();
        }
    };

    return (
        <Modal title='Rating Form' styles='gap-4' openState={openState} onClose={() => { onClose(undefined) }}>
            <div className='flex flex-col gap-6 md:gap-10'>
                <TextField placeholder={'Question'} inputValue={question.questionText} setInputValue={(e) => setQuestion({ ...question, questionText: e })} />
                {isScale(question.questionBody) && (
                    <div className='grid grid-cols-12 gap-4'>
                        {/* <TextField styles='col-span-6' label='Minimum' placeholder={'Min'} inputValue={question.questionBody.min.toString()} setInputValue={(e) => handleInputChange('min', e)} /> */}
                        <TextField styles='col-span-12' label='Maximum' placeholder={'Max'} inputValue={question.questionBody.max.toString()} setInputValue={(e) => handleInputChange('max', e)} />
                    </div>
                )}
                <button onClick={handleSubmit} className='w-full bg-[#3da8e2] text-white p-2 rounded-md border-[#8dd2f6] border shadow-black shadow-lg font-BardotBold tracking-widest'>Add Question</button>
            </div>
        </Modal>
    )

}

export default ScaleForm;